<form [formGroup]="taskForm" (ngSubmit)="onSubmit()">
  <input type="hidden" id="TaskId" formControlName="TaskId">
  <h2 mat-dialog-title>NEW TASK</h2>
  <mat-dialog-content style="font-size: smaller;">
    <input type="hidden" id="ObjectiveId" formControlName="ObjectiveId"/>
    <mat-form-field appearance="fill" style="width: 380px;">
      <mat-label>Task</mat-label>
      <input matInput id="Title" type="text" formControlName="Title">
    </mat-form-field>
    <br/>
    <mat-form-field appearance="fill" style="width: 380px;">
      <mat-label>Decription</mat-label>
      <textarea  matInput id="Description" type="text" formControlName="Description"></textarea>
    </mat-form-field>
    <br/>
    <mat-form-field appearance="fill">
      <mat-label>Objective owner</mat-label>
      <mat-select formControlName="Owner">
        <mat-option value="one">Andreas Holmberg</mat-option>
        @for (usr of this.users; track usr) {
          <mat-option [value]="usr.UserId">{{usr.LastName}}, {{usr.FirstName}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <br/>

    <mat-form-field appearance="fill" class="smallinput">
      <mat-label>Target date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="TargetDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <br/>



  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="submit" [disabled]="!taskForm.valid">CREATE</button>
    <button mat-button mat-dialog-close>CANCEL</button>

  </mat-dialog-actions>


</form>


